export const sepaDirectDebit=`<p>SEPA Direct Debits are not managed in Lloyds Bank Gem Connect however postings related to SEPA Direct Debit activity can be viewed in Transaction History and bank statements.</p>`;


// WEBPACK FOOTER //
// ./src/components/content/payments/12-sepaDirectDebit.ts